import * as ScrollMagic from '@modules/scrollmagic';
import { isEditMode } from '@js/utils';

export default class Index {
  constructor(rootNode) {
    if (isEditMode()) {
      return;
    }

    this.$refs = {
      rootNode,
      slides: rootNode.querySelectorAll('.TextImageSticky'),
      slidesCounter: rootNode.querySelector('.slides-counter'),
      slidesEnd: rootNode.querySelector('.slides-end'),
    };

    this.setupScrollMagic();
  }

  setupScrollMagic() {
    const controller = new ScrollMagic.Controller();

    new ScrollMagic.Scene({
      triggerElement: this.$refs.rootNode,
      triggerHook: 0,
    })
      .setClassToggle(this.$refs.slidesCounter, 'fixed')
      .addTo(controller);

    new ScrollMagic.Scene({
      triggerElement: this.$refs.slidesEnd,
      triggerHook: 1,
    })
      .setClassToggle(this.$refs.slidesCounter, 'bottom')
      .addTo(controller);

    Object.entries(this.$refs.slides).forEach(([key, slide]) => {
      new ScrollMagic.Scene({
        triggerElement: slide,
        triggerHook: 0.5,
        duration: slide.clientHeight,
      })
        .on('enter leave', (e) => {
          const selector = this.$refs.slidesCounter.querySelector(
            '[data-slide="' + key + '"]',
          );

          if (e.type === 'enter') {
            selector.classList.add('active');
          } else {
            selector.classList.remove('active');
          }
        })
        .addTo(controller);
    });
  }
}
